import styled from '@emotion/styled';
import Paper from '@mui/material/Paper';

import NumberInput from '../../components/NumberInput';
import { layout, colors, typo } from '../../components/tokens';

export const Product = styled.div``;

export const ProductHeader = styled.section`
  display: block;
  max-width: 1400px;
  margin: 3.5rem auto 0.2rem;
  min-height: 100vh;
`;

export const ProductHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top: 40px;
  flex-direction: row;
  @media (max-width: 1050px) {
  }
  @media (max-width: 688px) {
    flex-direction: column;
  }
`;

/**
 * ProductDetails
 */
export const DetailsWrapper = styled.div`
  display: block;
  width: calc(38vw - 16px);
  max-width: 600px;
  padding-left: 1.25rem;
  @media (max-width: 1050px) {
    width: calc(50% - 40px);
  }
  @media (max-width: 820px) {
    width: calc(99vw - 430px);
    padding-left: calc(430px - 50%);
  }
  @media (max-width: 688px) {
    width: 90%;
    padding-left: 10px;
  }
  a,
  button {
    width: 80%;
    max-width: 330px;
  }
`;
export const ProductTitle = styled.h1`
  font-size: 0.85rem;
  line-height: 1.4rem;
  letter-spacing: 0.5px;
  font-weight: 400;
  margin: 0;
  margin-bottom: 1rem;
`;

export const ProductPrice = styled.div`
  font-size: ${typo.small};
  line-height: ${typo.lineRegular};
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 1.25rem;
  @media (min-width: 768px) {
    font-size: ${typo.small};
  }
`;

export const ProductDescription = styled.section`
  display: block;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 1rem;
`;
export const DescriptionWrapper = styled.section`
  display: block;
  width: 100%;
  max-width: 100vw;
  margin: 0.25rem 0rem;
`;

export const ProductDescriptionDetail = styled.div`
  font-size: ${typo.small};
  line-height: ${typo.lineSmall};
  font-weight: 300;
  letter-spacing: 0.2px;
  width: 100%;
  margin: 0 auto;
  ul {
    display: flex;
    flex-wrap: wrap;
  }
  ul li {
    width: 48%;
    padding: 0 2.5rem 0 0;
    margin: 0 0;
    font-size: 0.8rem;
    font-weight: 400;
    color: #202324;
    line-height: 1.4rem;
    @media (max-width: 800px) {
      width: 98%;
    }
  }

  img {
    margin: -4px 0 0 0;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const ProductOptions = styled.div`
  margin-bottom: 1.25rem;
`;
export const ProductName = styled.h4`
  font-size: ${typo.small};
  line-height: ${typo.lineRegular};
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 0.625rem;
`;

// product option selection with name and value
export const ProductValues = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;
interface ValueProps {
  active: boolean;
  available: boolean;
  color?: string;
  src?: string;
  alt?: string;
};
export const ProductValue = styled.div<ValueProps>`
  display: flex;
  align-items: center;
  min-width: 100px;
  min-height: 100px;
  text-align: center;
  border: 1.2px solid #a6a6a6a6;
  padding: 0 ${layout.spacing}px;
  margin-right: ${layout.spacing}px;
  margin-bottom: ${layout.spacing}px;
  background-color: ${({ active }) => (active ? colors.primaryColor : 'transparent')};
  color: ${({ active }) => (active ? colors.colorOnPrimary : colors.color)};
  font-size: ${typo.small};
  font-weight: 400;
  cursor: pointer;
`;
export const ActiveWrapper = styled(Paper)<ValueProps>`
  border-color: ${props => (props.available && props.active ? '#ff4747' : '#00000022')};
`;
export const ProductColorValue = styled.img<ValueProps>`
  width: 95px;
  height: 95px;
  cursor: pointer;
  // ${({ available }) => (!available ? 'filter: grayscale(80%); opacity: 0.5;' : '')};
  // ${({ active }) => (active ? 'filter: brightness(90%);' : '')};
  // z-index: ${({ active, available }) => (!available || active ? '-1;' : '')};
  &:hover {
    filter: brightness(80%);
  }
`;

// add to cart
export const ProductQuantity = styled(NumberInput)`
  font-size: ${typo.small};
  line-height: ${typo.lineRegular};
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 1.9rem;
`;

interface AddedMessageProps {
  added: boolean;
};

export const AddedMessage = styled.div<AddedMessageProps>`
  position: relative;
  font-size: ${typo.small};
  line-height: ${typo.lineSmall};
  font-weight: 600;
  transition: all 0.3s ease;
  text-align: center;
  z-index: ${({ added }) => (added ? '0' : '-1')};
  ${({ added }) => (added ? 'transform: translateY(10px); opacity: 1;' : 'transform: translateY(-50px); opacity: 0;')};
`;

export const SocialShareWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: left;
  cursor: pointer;
  margin-right: 2px;
  &:last-of-type {
    margin-right: 0;
  }
`;

// product trust images
export const ProductTrust = styled.ul`
  display: flex;
  justify-content: flex-start;
  list-style: none;
  width: 90vw;
  max-width: 320px;
`;
export const ProductTrustImage = styled.li`
  width: 22%;
  img {
    width: 100%;
  }
`;

/**
 * ProductImagesProductQuantity
 */
export const ImageWrapper = styled.div`
  display: flex;
  width: 60%;
  min-width: 320px;
  flex-direction: row;
  @media (max-width: 1050px) {
    flex-direction: column;
    justify-content: flex-start;
    width: 50%;
  }
`;
export const ActiveImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 400px;
  height: 400px;
  margin-top: 0;
  margin-left: 0;
  margin-bottom: 10px;
  @media (max-width: 400px) {
    width: 100vmin;
    height: 100vmin;
  }

  @media (max-width: 1050px) {
    padding: 0 auto;
  }
`;
export const ActiveImage = styled.div`
  margin-left: 0;
  width: 400px;
  height: 400px;
  @media (max-width: 400px) {
    width: 100%;
    height: 100%;
  }
  img {
    max-width: 100vw;
    max-height: 100vw;
    @media (max-width: 400px) {
      width: 100%;
      height: 100%;
    }
  }
`;
// all image thumbnail
export const AllImages = styled.div`
  display: flex;
  height: 200px;
  width: 320px;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  @media (max-width: 1050px) {
    order: 1;
    height: 410px;
    max-height: 500px;
    width: 410px;
    margin: 0 10px;
  }
  @media (max-width: 400px) {
    order: 1;
    height: 330px;
    width: 320px;
    margin: 0 0px;
  }
`;

interface ThumbnailProps {
  active: boolean;
};

export const Thumbnail = styled(Paper)<ThumbnailProps>`
  cursor: pointer;
  ${props => (props.active ? 'filter: brightness(90%);' : '')};
  &:hover {
    filter: brightness(90%);
  }
  &:first-of-type {
    margin-left: 0;
  }
`;
export const ImageSliderArrow = styled.div``;
